import { QueryClient } from "@tanstack/react-query"

export const queryClient = new QueryClient({
    defaultOptions:{
        queries:{
            staleTime:90000,
            refetchOnWindowFocus:false
        }
    }
})